import { isContinuityMicLabel } from "./DeviceManager";
import { isVirtualAudioDevice } from "./virtualAudioPatterns";

function isMacBookMicrophone(label: string): boolean {
  return /macbook/i.test(label) && /microphone/i.test(label);
}

function isBuiltIn(label: string): boolean {
  return /built-?in/i.test(label);
}

/**
 * Pick the best non-Continuity audio input device to suggest as a swap target.
 * Ranking: MacBook + Microphone → Built-in → first remaining (excluding
 * iPhone/iPad and known virtual drivers). Returns null when no eligible
 * candidate exists (caller should suppress the alert in that case).
 *
 * Virtual-driver exclusion uses the canonical list from virtualAudioPatterns.ts,
 * which is also used by DeviceManager's auto-pick de-prioritization. Adding
 * a pattern there also tightens this filter.
 */
export function suggestedNonContinuityMic(
  devices: MediaDeviceInfo[],
): MediaDeviceInfo | null {
  const candidates = devices.filter((d) => {
    if (!d.label) return false;
    if (isContinuityMicLabel(d.label)) return false;
    if (isVirtualAudioDevice(d)) return false;
    return true;
  });

  if (candidates.length === 0) return null;

  const macBook = candidates.find((d) => isMacBookMicrophone(d.label));
  if (macBook) return macBook;

  const builtIn = candidates.find((d) => isBuiltIn(d.label));
  if (builtIn) return builtIn;

  return candidates[0];
}
